import { render } from "./KronenInfo.vue?vue&type=template&id=6225336a"
import script from "./KronenInfo.vue?vue&type=script&lang=js"
export * from "./KronenInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__